var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'react-emotion';
import t from '@jetshop/intl';
export const Table = styled('table') `
  width: 100%;
  overflow: hidden;

  svg {
    height: 1rem;
    width: 1rem;
  }
  ul {
    list-style-type: disc;
    margin-left: 1rem;
  }

  tr {
    > * {
      line-height: 2rem;
    }
    th {
      text-align: left;
      font-weight: 600;
      padding-right: 0.5rem;
    }
  }
`;
const StringValues = ({ stringValue, title }) => (React.createElement("tr", null,
    React.createElement("th", null, title),
    React.createElement("td", null, stringValue)));
const HtmlValues = ({ htmlValue, title }) => {
    const value = { __html: htmlValue };
    return (React.createElement("tr", null,
        React.createElement("th", null, title),
        React.createElement("td", { dangerouslySetInnerHTML: value })));
};
const BoolValues = ({ boolValue, title }) => (React.createElement("tr", null,
    React.createElement("th", null, title),
    React.createElement("td", null, boolValue ? React.createElement("div", null, t('Yes')) : React.createElement("div", null, t('No')))));
const ListValues = ({ listValues, title }) => (React.createElement("tr", null,
    React.createElement("th", null, title),
    React.createElement("td", null,
        React.createElement("ul", null, listValues.map(val => (React.createElement("li", { key: val }, val)))))));
const renderFieldPair = (field, index) => {
    const type = field.type;
    switch (type) {
        case 'STRING':
            return React.createElement(StringValues, Object.assign({}, field, { key: index }));
        case 'HTML':
            return React.createElement(HtmlValues, Object.assign({}, field, { key: index }));
        case 'BOOL':
            return React.createElement(BoolValues, Object.assign({}, field, { key: index }));
        case 'LIST':
            return React.createElement(ListValues, Object.assign({}, field, { key: index }));
        default:
            break;
    }
};
const ProductSpecifications = (_a) => {
    var { fields } = _a, rest = __rest(_a, ["fields"]);
    return fields ? (React.createElement(Table, Object.assign({}, rest),
        React.createElement("tbody", null, fields.map((field, index) => {
            return renderFieldPair(field, index);
        })))) : null;
};
export default ProductSpecifications;
//# sourceMappingURL=ProductSpecifications.js.map